<template>
  <div class="container-fluid billing-page">
    <div class="row">
      <div class="col-md-12">
        <div class="top-title-wrap">
          <div class="main-title">
            <span>{{ $t('Billing') }}</span>
          </div>
        </div>
        <div v-if="!$auth.hasPermission('billing')" class="billing-notice">
          <div class="icon">
            <img width="48" height="48" src="@/images/billing-notice.svg" alt="">
          </div>
          <div class="text">Please note, direct deposits on our platform are currently inactive for your account.
            <br>For payment assistance, please contact our Sales Representatives. <br>We appreciate your understanding.
          </div>
          <div class="button-wrap">
            <a class="button primary" href="mailto:dsp@smartyads.com">Contact us</a>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div :class="{'disabled-wrap':!$auth.hasPermission('billing')}" class="row">
        <div class="col-md-3">
          <box boxClass="billing-balance box-flex direction-column">
            <span>{{ $t('Your balance is:') }}</span>
            <span class="balance">$ {{ $auth.user().balance | finance }}</span>
          </box>
        </div>
        <div class="col-md-3" v-if="$auth.hasRole('agency') && $auth.user().agencyMarginType==='postDeductedMargin'">
          <box boxClass="billing-balance box-flex direction-column">
            <span>{{ $t('Your profit is:') }}</span>
            <span class="balance">$ {{ agencyProfit | finance }}</span>
          </box>
        </div>
        <div :class="[$auth.hasRole('agency') && $auth.user().agencyMarginType==='postDeductedMargin'? 'col-md-3':'col-md-4']">
          <box boxClass="billing-balance box-flex direction-column add-promo">
            <span>{{ $t('Enter Promo Code here:') }}</span>

            <div class="wrap mt-10">
              <dspInput v-model="promoCode" :is-disabled="!$auth.hasPermission('billing')" class="min-width"/>
              <dspButton @click="attachPromoCode"
                         :is-disabled="!$auth.hasPermission('billing')"
                         class="primary">{{ $t('Apply') }}
              </dspButton>
            </div>
          </box>
        </div>
        <div :class="[$auth.hasRole('agency') && $auth.user().agencyMarginType==='postDeductedMargin'? 'col-md-3':'col-md-5']">
          <box boxClass="billing-balance box-flex direction-column">
            <span>{{ $t('Notify by email when balance reaches:') }}</span>

            <!-- <span>{{ $t('Get notification email when balance level reaches') }}</span> -->
            <inputGroup class="short mt-10" prepend="$">
              <dspInput v-model="minBalanceNotification"
                        :is-disabled="!$auth.hasPermission('billing')"
                        placeholder="0"></dspInput>
              <dspButton @click="saveMinBalanceSum"
                         :is-disabled="!$auth.hasPermission('billing')"
                         class="primary">{{ $t('Save') }}
              </dspButton>
            </inputGroup>
          </box>
        </div>
        <beneficiary-manager class="mt-40" @input="handleChangeBeneficiaries" />
        <div class="col-md-12">
        

          <div :class="{ disabled: isDepositDisabled }">
            <box class="deposit-box">
              
              
              <div class="main-title">
                <span>{{ $t('Deposit') }} <img width="14" class="ml-2" src="@/images/tooltip.svg" alt="tooltip svg" v-b-tooltip :title="'For any invoice-related questions, please contact finance@smartyads.com'" /></span>
              </div>
              
              
           
              <div  class="beneficiary form-group mt-30">
                  <div class="group-title">Beneficiary Info <span class="text-danger">*</span></div>
                  <dropdown
                    v-model="selectedBeneficiary"
                    search-placeholder="Search beneficiary"
                    drop-value="Select Beneficiary Info"
                    :show-search="true"
                    :options="filteredBeneficiaries"
                    @search="beneficiarySearch = $event"
                  >
                    <template #header="{ value }">
                      <span>{{ get(value, 'text') || value }}</span>
                    </template>
                    <template #item="{ option }">
                      <span>{{ get(option, 'text') }}</span>
                    </template>
                  </dropdown>
                </div>

             
              
              
              <div class="main-title">{{ $t('How would you like to deposit:') }}</div>
              <div class="deposit-variant">
                <!-- Wire Transfer FIRST -->
                <div @click="$auth.hasPermission('billing') ? activeTab=2: ''"
                     class="item"
                     :class="{'disabled':!$auth.hasPermission('billing')}">
                  <input :checked=" activeTab === 2" id="dep-wire" type="radio" name="deposit">
                  <label for="dep-wire">
                    <div class="recommended-badge">{{ $t('Recommended') }}</div>
                    <div class="icon">
                      <span class="payment-icon payment-icon-wire" aria-hidden="true"></span>
                    </div>
                    <div class="text">{{ $t('Wire Transfer') }}</div>
                  </label>
                </div>

                <!-- Stripe SECOND -->
                <div
                  v-if="isStripeAvailable"
                  @click="$auth.hasPermission('billing') ? activeTab=6 : '' "
                  class="item"
                  :class="{'disabled':!$auth.hasPermission('billing')}"
                >
                  <input :checked="activeTab === 6" id="dep-stripe" type="radio" name="deposit">
                  <label for="dep-stripe">
                    <div class="icon">
                      <img height="40px" src="../images/stripe.png" alt="">
                    </div>
                    <div class="text">{{ $t('Stripe') }}</div>
                  </label>
                </div>
                
                <!-- Debit / Credit Card -->
                <div
                  v-if="isCreditCardAvailable"
                  @click="$auth.hasPermission('billing') ? activeTab=9 : '' "
                  class="item"
                  :class="{'disabled':!$auth.hasPermission('billing')}"
                >
                  <input :checked="activeTab === 9" id="dep-stripe" type="radio" name="deposit">
                  <label for="dep-stripe">
                    <div class="icon">
                      <img height="24px" src="../images/deposit-credit.svg" alt="">
                    </div>
                    <div class="text">{{ $t('Debit / Credit Card') }}</div>
                  </label>
                </div>

                <!-- PayPal THIRD -->
                <div
                  v-if="isPayPalAvailable"
                  @click="$auth.hasPermission('billing') ? activeTab=3: ''"
                  class="item"
                  :class="{'disabled':!$auth.hasPermission('billing')}"
                >
                  <input :checked="activeTab === 3" id="dep-paypal" type="radio" name="deposit">
                  <label for="dep-paypal">
                    <div class="icon">
                      <span class="payment-icon payment-icon-paypal" aria-hidden="true"></span>
                    </div>
                    <div class="text">{{ $t('Pay Pal') }}</div>
                  </label>
                </div>

                <div
                  v-if="isPayoneerAvailable"
                  @click="$auth.hasPermission('billing') ? activeTab=8: ''"
                  class="item"
                  :class="{'disabled':!$auth.hasPermission('billing')}"
                >
                  <input :checked="activeTab === 8" :disabled="!$auth.hasPermission('billing')" id="dep-payoneer" type="radio" name="deposit">
                  <label for="dep-payoneer">
                    <div class="icon">
                      <img class="payoneer-logo" src="../images/payoneer-logo.svg" alt="" aria-hidden="true">
                    </div>
                    <div class="text">Payoneer</div>
                  </label>
                </div>

                <div @click="$auth.hasPermission('billing') ? activeTab=7: ''"
                     class="item" v-if="$auth.hasRole('agency') && $auth.user() && $auth.user().agencyMarginType === 'postDeductedMargin'"
                     :class="{'disabled':!$auth.hasPermission('billing')}">
                  <input :checked="activeTab === 7" id="dep-agency" type="radio" name="deposit">
                  <label for="dep-agency">
                    <div class="icon">
                      <span class="payment-icon payment-icon-smartyads" aria-hidden="true"></span>
                    </div>
                    <div class="text">{{ $t('SmartyAds') }}</div>
                  </label>
                </div>
              </div>
              
              <div v-show="!!this.selectedBeneficiary">
                <div class="deposit-recipient">
                  <span class="deposit-recipient-label">Depositing to:</span> {{depositRecipientName}}
                </div>
                
                
                <div v-show="activeTab === 2 || activeTab === 9">
                  <div class="mb-10">
                    <b v-if="activeTab === 9">You can deposit money via Debit / Credit Card</b>
                    <b v-if="activeTab === 2">You can deposit money via Wire Transfer</b>
                  </div>
                  <div>
                    {{ $t('Enter the deposit amount below and send your request. Your payment request will be sent to') }}
                    <a :href="'mailto:' + depositEmail"> {{ depositEmail }} </a>
                    {{ $t('Please wait for a response from our finance team.') }}
                  </div>
                  
                  <div class="deposit-title mt-30">
                    {{ $t('How much would you like to deposit?') }}
                  </div>
                  <div class="form-group stripe-amount-wrap">
                    <inputGroup class="full-input-group alt-error" prepend="$">
                      <dspInput
                        v-model="depositAmount"
                        v-validate="{ required: true, finance: true, finance_min_value: 1 }"
                        :data-vv-as="$t('DepositAmount')"
                        :errorsBag="errors"
                        :is-disabled="!$auth.hasPermission('billing')"
                        class="stripe-amount"
                        name="depositAgencyAmount"
                        placeholder="0"
                      />
                      <span v-show="errors.has('depositAgencyAmount')" id="forgot-email-tooltip2" class="help-block alt">
                        <span class="error-sign"></span>
                      </span>
                      <b-tooltip ref="tooltip-forgot-email" placement="top" target="forgot-email-tooltip2">
                        {{ errors.first('depositAgencyAmount') }}
                      </b-tooltip>
                    </inputGroup>
                  </div>
                  <div class="form-group stripe-amount-wrap">
                    <dspButton :is-disabled="!$auth.hasPermission('billing') || errors.has('depositAgencyAmount') || isPaymentRequestSending" class="primary w-100" @click="submitEmailDeposit()">
                      {{ $t('Send Request') }}
                    </dspButton>
                  </div>
                </div>
                
                
                <div v-show="activeTab === 3">
                  <div class="deposit-title mt-30">
                    {{ $t('How much would you like to deposit?') }}
                  </div>
                  <inputGroup class="short group-error input-group-paypal" prepend="$">
                    <dspInput
                      v-model="depositAmount"
                      v-validate="'required|checkMinDeposit'"
                      :errorsBag="errors"
                      name="depositAmount"
                      placeholder="0"
                    />
                    <span v-show="errors.has('DepositAmount')" id="forgot-email-tooltip" class="help-block alt">
                      <span class="error-sign"></span>
                    </span>
                    <b-tooltip ref="tooltip-forgot-email" target="forgot-email-tooltip" placement="top">
                      {{ errors.first('DepositAmount') }}
                    </b-tooltip>
                    <div id="paypal-button" class="paypal-button"></div>
                  </inputGroup>
                </div>
                
                
                <div v-show="activeTab === 8">
                  <div>{{ $t('To deposit funds via Payoneer, please use the following details') }}</div>
                  <div>
                    {{ $t('Payoneer ID: ') }}
                    <a :href="'mailto:' + depositEmail"> {{ depositEmail }} </a>
                  </div>
                </div>
                
                <div v-show="activeTab === 6">
                  <div class="deposit-title mt-30">
                    {{ $t('How much would you like to deposit?') }}
                  </div>
                  <div class="form-group stripe-amount-wrap">
                    <inputGroup class="full-input-group alt-error" prepend="$">
                      <dspInput v-model="depositAmount"
                                class="stripe-amount"
                                v-validate="'required|checkMinDeposit'"
                                :errorsBag="errors"
                                :data-vv-as="$t('DepositAmount')"
                                :is-disabled="!$auth.hasPermission('billing')"
                                name="depositAmount"
                                placeholder="0"/>
                      <span v-show="errors.has('DepositAmount')" id="forgot-email-tooltip2" class="help-block alt">
                        <span class="error-sign"></span>
                      </span>
                      <b-tooltip ref="tooltip-forgot-email" target="forgot-email-tooltip2" placement="top">
                        {{ errors.first('DepositAmount') }}
                      </b-tooltip>
                    </inputGroup>
                  </div>
                  <stripe-element-card
                    v-if="!isLocal && pulishableKey"
                    :key="pulishableKey"
                    ref="elementRef"
                    :pk="pulishableKey"
                    @token="tokenCreated"
                    :disabled="!$auth.hasPermission('billing')"
                  />
                  <div class="form-group stripe-amount-wrap">
                    <dspButton @click="submitStripe()" :is-disabled="!$auth.hasPermission('billing') || !pulishableKey" class="primary w-100">
                      {{ $t('Deposit') }}
                    </dspButton>
                  </div>
                
                
                </div>
                <div v-show="activeTab === 7 && $auth.hasRole('agency') && $auth.user() && $auth.user().agencyMarginType === 'postDeductedMargin'">
                  <div class="deposit-title mt-30">{{ $t('How much would you like to deposit?') }}</div>
                  <div class="form-group stripe-amount-wrap">
                    <inputGroup class="full-input-group alt-error" prepend="$">
                      <dspInput v-model="depositAmount"
                                class="stripe-amount"
                                v-validate="{ required: true, finance: true, finance_min_value: 1,finance_max_value:agencyProfit }"
                                :errorsBag="errors"
                                :data-vv-as="$t('DepositAmount')"
                                :is-disabled="!$auth.hasPermission('billing')"
                                name="depositAgencyAmount"
                                placeholder="0"/>
                      <span v-show="errors.has('depositAgencyAmount')"
                            id="forgot-email-tooltip2"
                            class="help-block alt"><span class="error-sign"></span></span>
                      <b-tooltip ref="tooltip-forgot-email" target="forgot-email-tooltip2" placement="top">
                        {{ errors.first('depositAgencyAmount') }}
                      </b-tooltip>
                    </inputGroup>
                  </div>
                  <div class="form-group stripe-amount-wrap">
                    <dspButton @click="submitAgencyPostMarginDeposit()"
                               :is-disabled="!$auth.hasPermission('billing')"
                               class="primary w-100  mt-2">{{ $t('Deposit') }}
                    </dspButton>
                  </div>
                </div>
              </div>
              
              
              
              <div class="promo-added" v-if="$auth.user().activePromoCode">
                <div class="icon">
                  <img src="../images/promo-icon.svg" alt="">
                </div>
                <div class="text">Promo Code
                  <b> {{ $auth.user().activePromoCode.code }}</b> for +{{ $auth.user().activePromoCode.promo.percent }}% activated
                </div>
              </div>
            </box>
          </div>
        </div>
      </div>
      <loader :enabled="showLoader"></loader>
      <div class="row">

        <template v-if="$auth.hasRole('agency')">
          <div class="col-md-12">
            <div class="top-title-wrap agency-switch">
              <dspButton :class="{active:activeSecondTab==='transaction'}" @click="activeSecondTab='transaction'">
                {{ $t('Transactions') }}
              </dspButton>
              <dspButton :class="{active:activeSecondTab==='users'}" @click="activeSecondTab='users'">
                {{ $t('Users') }}
              </dspButton>
            </div>
          </div>

          <div class="col-md-12" v-if="activeSecondTab==='users'">
            <box boxClass="alt">
              <tableTopActions>
                <dspInput v-model="searchTextAgency"
                          :placeholder="$t('Search')"
                          class="search-input"
                          @keyup="searchAgency($event)"></dspInput>
                <dropdown :dropValue="filterAgency"
                          :showSearch="false"
                          :options="filtersAgency"
                          @input="filterAgency = $event"></dropdown>
              </tableTopActions>

              <b-table hover
                       ref="agencyUsersTable"
                       :fields="agencyUsersTableFields"
                       :items="agencyUsersProvider"
                       :busy="isBusyAgencyUsersTable"
                       :sort-by.sync="sortByAgencyUsers"
                       :sort-desc.sync="sortDescAgencyUsers"
                       :show-empty="true"
                       :empty-text="$t('No data to display')"
                       :no-sort-reset="true">
                <template slot="empty">
                  <div class="empty-table">
                    <h4>{{ $t('No data to display') }}</h4>
                  </div>
                </template>
                <template slot="name" slot-scope="data">
                  {{ data.item.firstName }} {{ data.item.lastName }}
                </template>
                <template slot="actions" slot-scope="data">
                  <a @click.prevent="showDepositAgencyModal(data.item)" href="#" class="mr-3"> Deposit</a> <a
                    @click.prevent="showWithdrawAgencyModal(data.item)"
                    href="#"> Withdraw</a>
                </template>

              </b-table>
              <b-pagination v-model="paginationAgencyUsers.currentPage"
                            :total-rows="paginationAgencyUsers.totalRows"
                            :per-page="paginationAgencyUsers.perPage"
                            align="right"
                            aria-controls="data-table"
                            @change="changePageAgency"
                            v-if="itemsAgency.length >= paginationAgencyUsers.perPage || paginationAgencyUsers.currentPage != 1"></b-pagination>
            </box>
          </div>


          <div class="col-md-12" v-if="activeSecondTab==='transaction'">
            <box boxClass="alt">
              <tableTopActions>
                <dspInput v-model="searchText"
                          :placeholder="$t('Search')"
                          class="search-input"
                          @keyup="searchTran($event)"></dspInput>
                <dropdown :dropValue="filter"
                          :showSearch="false"
                          :options="filters"
                          @input="filter = $event"></dropdown>
              </tableTopActions>

              <b-table hover
                       ref="tranTable"
                       :fields="fields"
                       :items="tranProvider"
                       :busy="isBusy"
                       :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc"
                       :show-empty="true"
                       :empty-text="$t('No data to display')"
                       :no-sort-reset="true">
                <template slot="empty">
                  <div class="empty-table">
                    <h4>{{ $t('No data to display') }}</h4>
                  </div>
                </template>
                <template v-for="(title, field) in sortableFields">
                  <template :slot="'HEAD_' + field">
                    <sortableColumnHead :title="title" :key="field"/>
                  </template>
                </template>

                <template slot="status" slot-scope="data">
                  <span :class="data.item.status">{{ data.item.status }}</span>
                </template>
                <template slot="transactionAmount" slot-scope="data">
                  <span :class="data.item.status">$ {{ data.item.transactionAmount | finance }}</span>
                </template>
                <template slot="balanceAfter" slot-scope="data">
                  <span v-if="data.item.status==='completed'">$ {{ data.item.balanceAfter | finance }}</span> <span
                    v-else-if="data.item.status==='canceled'"></span> <span v-else>$ {{
                    Number.parseFloat($auth.user().balance) + Number.parseFloat(data.item.transactionAmount) | finance
                  }}</span>
                </template>
                <template slot="download" slot-scope="data">
                  <a @click.prevent="downloadTran(data.item.id)" href="#"><img src="../images/icon-invoice-download.svg"
                                                                               alt=""></a>
                </template>
              </b-table>
              <b-pagination v-model="pagination.currentPage"
                            :total-rows="pagination.totalRows"
                            :per-page="pagination.perPage"
                            align="right"
                            aria-controls="data-table"
                            @change="changePage"
                            v-if="items.length >= pagination.perPage || pagination.currentPage != 1"></b-pagination>
            </box>
          </div>

        </template>
        <div class="col-md-12" v-else>
          <div class="row">
            <div class="col-md-12">
              <div class="top-title-wrap">
                <div class="main-title">
                  <span>{{ $t('Transactions') }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <box boxClass="alt">
                <tableTopActions>
                  <dspInput v-model="searchText"
                            :placeholder="$t('Search')"
                            class="search-input"
                            @keyup="searchTran($event)"></dspInput>
                  <dropdown :dropValue="filter"
                            :showSearch="false"
                            :options="filters"
                            @input="filter = $event"></dropdown>
                </tableTopActions>

                <b-table hover
                         ref="tranTable"
                         :fields="fields"
                         :items="tranProvider"
                         :busy="isBusy"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         :show-empty="true"
                         :empty-text="$t('No data to display')"
                         :no-sort-reset="true">
                  <template slot="empty">
                    <div class="empty-table">
                      <h4>{{ $t('No data to display') }}</h4>
                    </div>
                  </template>
                  <template v-for="(title, field) in sortableFields">
                    <template :slot="'HEAD_' + field">
                      <sortableColumnHead :title="title" :key="field"/>
                    </template>
                  </template>

                  <template slot="status" slot-scope="data">
                    <span :class="data.item.status">{{ data.item.status }}</span>
                  </template>
                  <template slot="transactionAmount" slot-scope="data">
                    <span :class="data.item.status">$ {{ data.item.transactionAmount | finance }}</span>
                  </template>
                  <template slot="balanceAfter" slot-scope="data">
                    <span v-if="data.item.status==='completed'">$ {{ data.item.balanceAfter | finance }}</span> <span
                      v-else-if="data.item.status==='canceled'"></span> <span v-else>$ {{
                      Number.parseFloat($auth.user().balance) + Number.parseFloat(data.item.transactionAmount) | finance
                    }}</span>
                  </template>
                  <template slot="download" slot-scope="data">
                    <a @click.prevent="downloadTran(data.item.id)"
                       href="#"><img src="../images/icon-invoice-download.svg" alt=""></a>
                  </template>
                </b-table>
                <b-pagination v-model="pagination.currentPage"
                              :total-rows="pagination.totalRows"
                              :per-page="pagination.perPage"
                              align="right"
                              aria-controls="data-table"
                              @change="changePage"
                              v-if="items.length >= pagination.perPage || pagination.currentPage != 1"></b-pagination>
              </box>
            </div>
          </div>

        </div>

      </div>
    </div>

    <b-modal modal-class="billing-modal" ref="ConfirmPromoCodeModal">
      <div slot="modal-header"></div>
      <div class="text-center">
        You already have an activated promo code. Do you want to activate another one? <br>
        <small class="text-danger"> (promo codes do not stack and will be applied in turn) </small>
      </div>
      <div slot="modal-footer">
        <dspButton class="plain" v-on:click="$refs.ConfirmPromoCodeModal.hide()">{{ $t('Cancel') }}</dspButton>
        <dspButton class="primary" v-on:click="$refs.ConfirmPromoCodeModal.hide();attachPromoCode(true); ">
          {{ $t('Yes') }}
        </dspButton>
      </div>
    </b-modal>

    <b-modal modal-class="billing-modal" ref="depositAgencyModal" dialog-class="small" footer-class="alt">
      <div slot="modal-header">
        <h5>{{ $t('Deposit for  ') }}</h5> <h4> {{ this.userAgencyModal.name }}</h4>
      </div>
      <div class="form-group full-width">

        <label class="group-title">{{ $t('How much would you like to deposit') }}</label>
        <dspInput :placeholder="$t('0')"
                  v-model="depositAgencyModify"
                  :is-disabled="isDepositAgencySaving"
                  v-validate="{
                                          finance: true,
                                          finance_min_value:1,
                                          finance_max_value:$auth.user().balance
                                      }"
                  :data-vv-as="$t('depositAgencyModify')"
                  :errorsBag="errors"
                  name="depositAgencyModify"

        />
      </div>

      <div slot="modal-footer">
        <dspButton v-on:click="$refs.depositAgencyModal.hide()" :is-disabled="isDepositAgencySaving" class="plain">{{ $t('Cancel') }}
        </dspButton>
        <dspButton v-on:click="updateDepositAgency" :is-disabled="isDepositAgencySaving" class="primary">{{ isDepositAgencySaving ? $t('Saving...') : $t('Save') }}
        </dspButton>
      </div>
    </b-modal>
    <b-modal modal-class="billing-modal" ref="withdrawAgencyModal" dialog-class="small" footer-class="alt">
      <div slot="modal-header">
        <h5>{{ $t('Withdraw for ') }}</h5> <h4> {{ this.userAgencyModal.name }}</h4>
      </div>
      <div class="form-group full-width">

        <label class="group-title">{{ $t('How much would you like to Withdraw') }}</label>
        <dspInput :placeholder="$t('0')"
                  v-model="withdrawAgencyModify"
                  :is-disabled="isWithdrawAgencySaving"
                  v-validate="{
                                          finance: true,
                                          finance_min_value:1,
                                          finance_max_value:this.userAgencyModal.balance
                                      }"
                  :data-vv-as="$t('withdrawAgencyModify')"
                  :errorsBag="errors"
                  name="withdrawAgencyModify"

        />
      </div>

      <div slot="modal-footer">
        <dspButton v-on:click="$refs.withdrawAgencyModal.hide()" :is-disabled="isWithdrawAgencySaving" class="plain">{{ $t('Cancel') }}
        </dspButton>
        <dspButton v-on:click="updateWithdrawAgency" :is-disabled="isWithdrawAgencySaving" class="primary">{{ isWithdrawAgencySaving ? $t('Saving...') : $t('Save') }}
        </dspButton>
      </div>
    </b-modal>

    <b-modal modal-class="billing-modal" ref="confirmPaymentModal" dialog-class="custom-footer medium" footer-class="alt">
      <div slot="modal-header">
        <h5>{{ $t('Please confirm the following information below:  ') }}</h5>
      </div>
      <div class="form-group full-width">
        <h6>
          Your ID: <span class="font-weight-bold"> {{ $auth.user().id }} </span> <br> Email:
          <span class="font-weight-bold">  {{ $auth.user().email }} </span> <br> Amount:
          <span class="font-weight-bold">  {{ depositAmount }}</span>
        </h6>
      </div>

      <div slot="modal-footer" class="w-100 d-flex">
        <span class="mr-auto"></span>
        <div class="wrap">

          <dspButton v-on:click="$refs.confirmPaymentModal.hide()" class="plain">{{ $t('Cancel') }}
          </dspButton>
          <dspButton v-on:click.once="confirmPayment" class="primary">{{ $t('Confirm') }}
          </dspButton>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import paypal from 'paypal-checkout';

import { debounce } from 'debounce';
import sortableColumnHead from '@/components/shared/sortableColumnHead.vue';
import moment from 'moment';
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import { currencyFormatter, parse } from '@/lib/numberFormatters';
import BeneficiaryManager from "@/components/billing/BeneficiaryManager.vue";
import {BusinessType, businessTypeValues} from "@/services/billingBeneficiaryService";
import {get} from "lodash";

export default {
  name: 'billing',
  components: {
    BeneficiaryManager,
    sortableColumnHead,
    StripeElementCard
  },
  data: function () {
    return {
      activeInfoTab: 'legal',
      taxType: null,
      isDepositDisabled: true,
      isPaymentRequestSending: false,
      activeSecondTab: 'users',
      activeTab: 2, // Wire Transfer by default
      depositAmount: '1000',
      defaultDepositAmount: '1000',
      paymentData: { // This data replacing on create this component
        name: '',
        cardNumber: '',
        expireDate: '',
        cvv: '',
      },
      minBalanceNotification: 20,
      transactionResult: {},
      showLoader: false,
      userId: null,
      ppPaymentId: null,
      isBusy: false,
      isBusyAgencyUsersTable: false,
      searchText: '',
      searchTextAgency: '',
      searchTextAgencyUsers: '',
      items: [],
      itemsAgency: [],
      agencyUsersTableFields: [{
        key: 'id',
        label: this.$t('User ID'),
        sortable: true
      }, {
        key: 'name',
        label: this.$t('Name'),
        sortable: true
      }, {
        key: 'balance',
        label: this.$t('Balance'),
        sortable: true
      },
        {

          key: 'actions',
          label: this.$t('Actions'),
          sortable: false,
          class: 'actions-column'
        },

      ],
      fields: [{
        key: 'id',
        label: this.$t('ID'),
        sortable: true
      }, {
        key: 'createdAt',
        label: this.$t('Date'),
        sortable: true
      }, {
        key: 'notes',
        label: this.$t('Description'),
        sortable: true,
        class: 'descr-field'
      }, {
        key: 'transactionAmount',
        label: this.$t('Amount'),
        sortable: true
      }, {
        key: 'balanceAfter',
        label: this.$t('Sum After'),
        sortable: false
      }, {
        key: 'type',
        label: this.$t('Type'),
        sortable: true
      }, {
        key: 'status',
        label: this.$t('Status'),
        sortable: true
      }, {
        key: 'methodString',
        label: this.$t('Method'),
        sortable: true
      },],
      sortableFields: {
        id: this.$t('ID'),
        createdAt: this.$t('Date'),
        notes: this.$t('Description'),
        transactionAmount: this.$t('Amount'),
        type: this.$t('Type'),
        status: this.$t('Status'),
        methodString: this.$t('Method'),
      },
      sortBy: 'id',
      sortByAgencyUsers: 'id',
      sortDesc: true,
      sortDescAgencyUsers: true,
      filter: this.$t('Date'),
      filters: [this.$t('ID'), this.$t('Date'), this.$t('Description'), this.$t('Amount'), this.$t('Type'), this.$t('Status'), this.$t('Method')],

      filterAgency: this.$t('User ID'),
      filtersAgency: [this.$t('User ID'), this.$t('User first name'), this.$t('User last name')],

      pagination: {
        currentPage: 1,
        perPage: 10,
        totalRows: 100,
      },
      paginationAgencyUsers: {
        currentPage: 1,
        perPage: 10,
        totalRows: 100,
      },
      minDep: this.$auth.user().isFirstPayment ? this.$auth.user().firstPaymentAmount : this.$auth.user().followingPaymentAmount,
      promoCode: '',
      depositAgency: 0,
      withdrawAgency: 0,
      isDepositAgencySaving: false,
      isWithdrawAgencySaving: false,
      userAgencyModal: {
        name: null
      },
      agencyProfit:0,

      selectedBeneficiary: null,
      beneficiaries: [],
      beneficiarySearch: ''
    }
  },

  computed: {
    filteredBeneficiaries() {
      const search = this.beneficiarySearch.trim().toLowerCase();
      return this.beneficiaries.filter(beneficiary => beneficiary.name.toLowerCase().includes(search));
    },
    depositEmail() {
      if(!this.selectedBeneficiary) {
        return '';
      }
      
      return this.selectedBeneficiary.businessType === BusinessType.INDIVIDUAL ? 'accounts@smartyads.com' : 'accounting@sidngroup.com';
    },
    depositRecipientName() {
      if (this.selectedBeneficiary && this.selectedBeneficiary.businessType === BusinessType.LEGAL) {
        return 'SIDN GROUP LTD (Cyprus)';
      }
      
      if (this.selectedBeneficiary && this.selectedBeneficiary.businessType === BusinessType.ENTREPRENEUR) {
        return 'SIDN GROUP LTD (Cyprus)';
      }
      
      if (this.selectedBeneficiary && this.selectedBeneficiary.businessType === BusinessType.INDIVIDUAL) {
        return 'SmartyAds LLP (UK)';
      }
      
      return 'SmartyAds LLP (UK)'
    },

    isPayoneerAvailable() {
      return !this.selectedBeneficiary || Boolean([BusinessType.LEGAL, BusinessType.ENTREPRENEUR, BusinessType.INDIVIDUAL].includes(this.selectedBeneficiary.businessType));
    },
    isStripeAvailable() {
      return !this.selectedBeneficiary || BusinessType.INDIVIDUAL === this.selectedBeneficiary.businessType;
    },
    isCreditCardAvailable() {
      return !this.selectedBeneficiary || Boolean([BusinessType.LEGAL, BusinessType.ENTREPRENEUR].includes(this.selectedBeneficiary.businessType));
    },
    isPayPalAvailable() {
      return !this.selectedBeneficiary || Boolean([BusinessType.LEGAL, BusinessType.ENTREPRENEUR].includes(this.selectedBeneficiary.businessType));
    },

    pulishableKey() {
      return this.selectedBeneficiary ? this.selectedBeneficiary.stripePublishableKey : '';
    },

    searchFilter: function () {
      switch (this.filter) {
        case this.$t('ID'):
          return 'id:like';
        case this.$t('Date'):
          return 'createdAt:like';
        case this.$t('Description'):
          return 'notes:like';
        case this.$t('Amount'):
          return 'transactionAmount:like';
        case this.$t('Type'):
          return 'type:like';
        case this.$t('Status'):
          return 'status:like';
        case this.$t('Method'):
          return 'method:like';
        default:
          return 'id:like';
      }
    },
    searchFilterAgency: function () {
      switch (this.filterAgency) {
        case this.$t('User ID'):
          return 'id:like';
        case this.$t('User first name'):
          return 'firstName:like';
        case this.$t('User last name'):
          return 'lastName:like';

        default:
          return 'id:like';
      }
    },

    stripeElements () {
      return this.$stripe.elements();
    },
    depositAgencyModify: {
      get: function () {
        return currencyFormatter(this.depositAgency);
      },
      set (val) {
        this.depositAgency = parse(val);

        this.$nextTick(() => {
          this.$validator.validate('depositAgencyModify', val);
        });
      }
    },
    withdrawAgencyModify: {
      get: function () {
        return currencyFormatter(this.withdrawAgency);
      },
      set (val) {
        this.withdrawAgency = parse(val);

        this.$nextTick(() => {
          this.$validator.validate('withdrawAgencyModify', val);
        });
      }
    },

    isLocal() {
      return process.env.NODE_ENV === 'local';
    }
  },

  watch: {
    isPayoneerAvailable(value) {
      if (!value && this.activeTab === 8) {
        this.activeTab = 2;
      }
    },

    activeTab (value) {
      if (value === 5) {
        return;
      }
      //Smarty
      if (value === 7) {
        this.depositAmount = String(this.agencyProfit == null ? '' : this.agencyProfit);
      }

      //Stripe and PayPal
      if (value === 3 || value === 6 || value === 8) {
        this.depositAmount = String(this.defaultDepositAmount == null ? '' : this.defaultDepositAmount);
      }

      this.errors.remove('depositAmount');
      this.errors.remove('depositAgencyAmount');

      if (this.$route.name === 'billing.webmoney-success' || this.$route.name === 'billing.webmoney-denied') {
        this.$router.push({ name: 'billing' });
      }
    },
    searchText: function () {
      this.$refs.tranTable.refresh();
    },
    searchTextAgency: function () {
      this.$refs.agencyUsersTable.refresh();
    }
  },

  created () {
    this.initPaymentData();
    let minDeposit = this.$auth.user().isFirstPayment ? this.$auth.user().firstPaymentAmount : this.$auth.user().followingPaymentAmount;
    this.$validator.localize('en', {
      attributes: {
        'depositAmount': 'depositAmount',
      },
      custom: {
        depositAmount: {
          checkMinDeposit: 'The Amount must be at least  ' + minDeposit + ' $',
        },
      }
    });
    this.$validator.extend('checkMinDeposit', {
      validate: async (value) => {
        let minDeposit = this.$auth.user().isFirstPayment ? this.$auth.user().firstPaymentAmount : this.$auth.user().followingPaymentAmount;

        return value >= minDeposit;
      }
    });

    if (this.$auth.hasRole('agency') && this.$auth.user().agencyMarginType === 'postDeductedMargin') {
      this.getAgencyProfit();
    }
  },

  beforeMount () {
    if (
        !this.$auth.hasRole('admin') &&
        (
            this.$auth.hasPermission('cant-see-prices') ||
            !this.$auth.user() ||
            (this.$auth.user().agencyType && this.$auth.user().agencyType === 'preDeductedMargin')
        )
    ) {
      return this.$router.push({ name: 'dashboard' });
    }
  },

  mounted: function () {
    this.getMinBalanceSum();
    const vue = this;

    if (!this.isLocal) {
      paypal.Button.render({
        env: process.env.VUE_APP_PAYPAL_ENV || 'production',
        payment: vue.payPalPayment,
        onAuthorize: vue.payPalOnAuthorize,
        onCancel: vue.payPalOnCancel,
      }, '#paypal-button');
    }

    this.getTransactionResult();
  },

  methods: {
    get,
    submitEmailDeposit() {
      if (this.isPaymentRequestSending) {
        return;
      }

      const paymentMethods = {
        9: 'Debit / Credit Card',
        2: 'Wire Transfer',
      };

      this.isPaymentRequestSending = true;
      this.$axios
        .post('billing/payment-request', {
          beneficiaryId: this.selectedBeneficiary.value,
          depositAmount: this.depositAmount,
          paymentMethod: paymentMethods[this.activeTab],
        })
        .then(res => {
          this.$notify.info(`Your payment request has been sent to ${res.data.email}. The finance team will contact you via the email in the selected Beneficiary Info.`);
        })
        .catch(error => {
          this.$backendErrors(error, this.$t('Error: '), this.$validator);
        })
        .finally(() => {
          this.isPaymentRequestSending = false;
        });
    },
    submitAgencyPostMarginDeposit () {
      this.$axios.post('deposit-from-profit-agency', {
        transactionAmount: this.depositAmount,
      }).then(res => {
        if (res.data.status === 'success') {
          this.$notify.info('Successfully deposited');
          setTimeout(() => {
            location.reload();
          }, 3000);
        } else {
          this.$notify.error('Error');
        }
      }).catch(error => {
        this.$backendErrors(error, this.$t('Error: '), this.$validator);
      });
    },
    getAgencyProfit () {
      this.$axios.get('agency-profit').then(res => {
        this.agencyProfit = res.data.profit;

      }).catch(error => {
        this.$backendErrors(error, this.$t('Error: '), this.$validator);
      });
    },
    updateDepositAgency () {
      if (this.isDepositAgencySaving) {
        return false;
      }

      this.$validator.validate('depositAgencyModify').then(valid => {
        if (!valid) {
          return false;
        }

        this.isDepositAgencySaving = true;

        this.$axios.post('deposit-agency-user', {
          userId: this.userAgencyModal.id,
          transactionAmount: this.depositAgency,
        }).then(res => {
          if (res.data.status === 'success') {
            // this.$auth.user().balance = res.data.balance;
            this.$notify.info('Success');
            // setTimeout(location.reload(), 2000);

          } else {
            this.$notify.error('Error');
          }

          this.$refs.agencyUsersTable.refresh();
        }).catch(error => {
          this.$backendErrors(error, this.$t('Error: '), this.$validator);
        }).finally(() => {
          this.isDepositAgencySaving = false;
          this.depositAgency = 0;
          this.$refs.depositAgencyModal.hide();
        });
      });

    },
    updateWithdrawAgency () {
      if (this.isWithdrawAgencySaving) {
        return false;
      }

      this.$validator.validate('withdrawAgencyModify').then(valid => {
        if (!valid) {
          return false;
        }

        this.isWithdrawAgencySaving = true;

        this.$axios.post('withdraw-agency-user', {
          userId: this.userAgencyModal.id,
          transactionAmount: this.withdrawAgency,
        }).then(res => {
          if (res.data.status === 'success') {
            // this.$auth.user().balance = res.data.balance;
            this.$notify.info('Success');
            // setTimeout(location.reload(), 2000);
          } else {
            this.$notify.error('Error');
          }
          this.$refs.agencyUsersTable.refresh();
        }).catch(error => {
          this.$backendErrors(error, this.$t('Error: '), this.$validator);
        }).finally(() => {
          this.isWithdrawAgencySaving = false;
          this.withdrawAgency = 0;
          this.$refs.withdrawAgencyModal.hide();
        });
      });

    },

    showDepositAgencyModal (user) {
      this.userAgencyModal = user;
      this.$refs.depositAgencyModal.show();
    },
    showWithdrawAgencyModal (user) {
      this.userAgencyModal = user;
      this.$refs.withdrawAgencyModal.show();
    },

    agencyUsersProvider (ctx) {
      let sortBy = ctx.sortBy;

      const params = new URLSearchParams();

      params.append('page', this.paginationAgencyUsers.currentPage);
      params.append('perPage', this.paginationAgencyUsers.perPage);
      params.append('search', this.searchTextAgency);
      params.append('searchFields', this.searchFilterAgency);
      params.append('orderBy', sortBy);
      params.append('sortedBy', ctx.sortDesc ? 'desc' : 'asc');
      params.append('where', 'ownerId;' + this.$auth.user().id);

      let promise = this.axios.get('agency-users', { params: params });
      return promise.then(response => {
        const items = response.data.data;
        this.paginationAgencyUsers.currentPage = response.data.meta.pagination.current_page;
        this.paginationAgencyUsers.perPage = response.data.meta.pagination.per_page;
        this.paginationAgencyUsers.totalRows = response.data.meta.pagination.total;

        this.itemsAgency = items;
        return items || [];
      }).catch(() => {
        this.paginationAgencyUsers.currentPage = 0;
        this.paginationAgencyUsers.perPage = 0;
        this.paginationAgencyUsers.totalRows = 0;
        return [];
      });
    },
    attachPromoCode (confirm = false) {

      if (this.promoCode.length <= 2) {
        return;
      }
      if (this.$auth.user().activePromoCode && confirm === false) {
        this.$refs.ConfirmPromoCodeModal.show();
        return;
      }

      this.$axios.post('users/attach-promo-code', {
        code: this.promoCode,
      })
          .then(response => {
            if (response.data === 'invalid_code') {
              this.$notify.error(this.$t('Incorrect code!'));
            }
            if (response.data !== 'invalid_code') {
              this.$notify.info(this.$t('Success'));
              if (this.$auth.user().activePromoCode === null) {

                this.$auth.user().activePromoCode = response.data.activePromoCode;
              }

              this.promoCode = '';
            }

          })
          .catch(() => {
            this.$notify.error(this.$t('Error!'));
          });
    },

    tokenCreated (token) {
      this.showLoader = true;

      this.$axios.post('/billing/stripe', {
        stripeToken: token,
        amount: this.depositAmount,
        beneficiaryId: this.selectedBeneficiary.value
      }).then(response => {
        this.showLoader = false;
        this.depositAmount = '1000';
        this.initPaymentData();
        // response.data.data.user.role = this.$auth.user().role;
        this.$auth.user().activePromoCode = response.data.data.activePromoCode;
        let mes = response.data.message.charAt(0).toUpperCase() + response.data.message.slice(1);
        this.$notify.info(mes, 20000);
      })
          .catch(error => {
            this.showLoader = false;

            return this.$notify.error(error.response.data && error.response.data.message ? error.response.data.message : error.statusText,);
          }).finally(() => {
        this.$refs.confirmPaymentModal.hide();
      });
    },

    confirmPayment () {
      this.$refs.elementRef.submit();
    },
    submitStripe () {

      // this will trigger the process
      this.$validator.errors.clear();

      let minDeposit = this.$auth.user().isFirstPayment ? this.$auth.user().firstPaymentAmount : this.$auth.user().followingPaymentAmount;

      if (this.depositAmount < minDeposit) {
        this.$validator.errors.add({
          field: 'depositAmount',
          msg: 'The Amount must be at least  ' + minDeposit + ' $',
          scope: null,
        });

        return false;
      }
      this.$refs.confirmPaymentModal.show();

    },

    getMinBalanceSum () {
      this.minBalanceNotification = String(this.$auth.user().minBalanceNotification || 0);
    },

    saveMinBalanceSum () {

      this.$axios
          .patch('/users/' + this.$auth.user().id, {
            'minBalanceNotification': this.minBalanceNotification,
          })
          .then((response) => {
            this.$notify.info(this.$t('Low budget sum updated'));
            response.data.data.role = this.$auth.user().role;
            this.$auth.user(response.data.data);
            this.getMinBalanceSum();
          })
          .catch(error => {
            this.$backendErrors(error, this.$t('Fail to update budget sum. '));
            // this.$notify.error(this.$t('Fail to update budget sum. ') + e.toString())
            this.getMinBalanceSum();
          });
    },

    searchTran: debounce(function (val) {
      this.searchText = val;
    }, 500),

    searchAgency: debounce(function (val) {
      this.searchTextAgency = val;
    }, 500),

    tranProvider (ctx) {
      let sortBy = ctx.sortBy;

      const params = new URLSearchParams();

      let dateFrom = '2014-01-01';
      let dateTo = moment().format('YYYY-MM-DD');

      params.append('from', dateFrom);
      params.append('to', dateTo);
      params.append('page', this.pagination.currentPage);
      params.append('search', this.searchText);
      params.append('searchFields', this.searchFilter);
      params.append('orderBy', sortBy === 'methodString' ? 'method' : sortBy);
      params.append('sortedBy', ctx.sortDesc ? 'desc' : 'asc');

      let promise = this.axios.get('/transactions', { params: params });
      return promise.then(response => {
        const items = response.data.data;

        this.pagination.currentPage = response.data.meta.pagination.current_page;
        this.pagination.perPage = response.data.meta.pagination.per_page;
        this.pagination.totalRows = response.data.meta.pagination.total;

        items.map((row) => {
          row.download = 2;
          return row;
        });

        this.items = items;
        return items || [];
      }).catch(() => {
        this.pagination.currentPage = 0;
        this.pagination.perPage = 0;
        this.pagination.totalRows = 0;
        return [];
      });
    },

    downloadTran (id) {
      let promise = this.axios.get('/transactions/download/' + id, { responseType: 'blob' });
      return promise.then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        window.open(fileURL);
      }).catch(() => {
        this.$notify.error(this.$t('Error occurs!'));
      });
    },

    changePage (pageNo) {
      this.pagination.currentPage = pageNo;
      this.$refs.tranTable.refresh();
    },
    changePageAgency (pageNo) {
      this.paginationAgencyUsers.currentPage = pageNo;
      this.$refs.agencyUsersTable.refresh();
    },

    initPaymentData () {
      this.$validator.reset();
    },

    payPalPayment (resolve, reject) {

      this.$validator.errors.clear();

      let minDeposit = this.$auth.user().isFirstPayment ? this.$auth.user().firstPaymentAmount : this.$auth.user().followingPaymentAmount;

      if (this.depositAmount < minDeposit) {
        this.$validator.errors.add({
          field: 'depositAmount',
          msg: 'The Amount must be at least  ' + minDeposit + ' $',
          scope: null,
        });

        return false;
      }
      this.showLoader = true;
      this.$axios.post('/billing/paypalcreatepayment', {
        paypalamount: this.depositAmount,
        userid: this.$auth.user().id,
        beneficiaryId: this.selectedBeneficiary.value
      })
          .then((response) => {
            this.$auth.user().activePromoCode = response.data.data.activePromoCode;

            this.ppPaymentId = response.data.data.paymentID;
            resolve(response.data.data.paymentID);
          })
          .catch((error) => {
            reject(error);
            this.showLoader = false;
            if (error.response.status !== 422) {
              return this.$notify.error(error.message ? error.message : error.statusText);
            }

            let responseErrors = error.response.data.errors;
            for (let key in responseErrors) {
              this.$validator.errors.add({
                field: key,
                msg: responseErrors[key][0],
                scope: null,
              });
            }
          });
    },

    payPalOnAuthorize ({paymentID}) {
      this.showLoader = true;
      const beneficiaryId = this.selectedBeneficiary.value;
      const urlParams = `?paymentID=${paymentID}&paypalamount=${this.depositAmount}&beneficiaryId=${beneficiaryId}`;
      this.$axios.post(`/billing/paypalexecutepayment${urlParams}`)
          .then((response) => {
            this.showLoader = false;
            this.depositAmount = 1000;
            response.data.data.user.role = this.$auth.user().role;
            // this.$auth.user(response.data.data.user);
            this.$notify.info(response.data.message, 20000);
            this.$refs.tranTable.refresh();
          })
          .catch(() => {
            this.showLoader = false;
            this.$notify.error(this.$t('Error occured!'));
          });
    },

    payPalOnCancel () {
      this.showLoader = true;
      this.$axios.post('/billing/paypalcancel', { pid: this.ppPaymentId }).then(() => {
        this.showLoader = false;
        this.$notify.info(this.$t('Transaction canceled'));
      }).catch(() => {
        this.showLoader = false;
        this.$notify.info(this.$t('Error occurs during handling Transaction'));
      });
    },

    getTransactionResult () {
      const result = this.$route.query;
      if (result.hasOwnProperty('transresult')) {
        this.transactionResult = JSON.parse(result.transresult);
        this.$router.replace({
          ...this.$router.currentRoute,
          query: {}
        });
        if (this.transactionResult.CreditCardResultSuccess === -1) {

          this.$notify.error(this.transactionResult.message);
        } else {
          this.$notify.info(this.transactionResult.message);
        }
      }
    },

    /**
     * Handle beneficiary change event.
     *
     * @param {{id: number|null, data: Object, isEdit: boolean}[]} value
     *
     * @return{void}
     */
    handleChangeBeneficiaries(value) {
      this.isDepositDisabled = !value.length || value.some(item => !item.id || item.isEdit);
      this.beneficiaries = value.filter(item => item.id).map(item => {
        const {data} = item;
        const name = data.businessType === BusinessType.LEGAL
          ? data.company
          : [data.firstName, data.lastName].filter(Boolean).join(' ');
        let text = `${name} (${businessTypeValues[data.businessType]})`;

        if (data.businessType === BusinessType.ENTREPRENEUR && data.taxIdentifierType && data.taxIdentifierNumber) {
          text += ` - ${data.taxIdentifierType.text}: ${data.taxIdentifierNumber}`;
        }

        return {value: item.id, name: name || '', text, businessType: data.businessType, stripePublishableKey: item.stripePublishableKey}
      });

      if (this.selectedBeneficiary) {
        const found = this.beneficiaries.find(beneficiary => beneficiary.value === this.selectedBeneficiary.value);
        this.selectedBeneficiary = found || null;
      }

      if (!this.selectedBeneficiary && this.beneficiaries.length === 1) {
        this.selectedBeneficiary = this.beneficiaries[0];
      }
    }
  }

};
</script>

<style lang="scss" scoped>
$W1280: 1280px;

@mixin mediaDesktop($width) {
  @media only screen and (max-width: #{$width}) {
    @content;
  }
}

.billing-balance {
  padding-top: 28px;
  padding-left: 30px;

  &.add-promo {
    .wrap {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 10px;
    }

    .input-wrap {
      margin-right: 10px;
    }
  }

  span {
    padding-bottom: 4px;
    display: block;

    &.balance {
      font-weight: 500;
      font-size: 38px;
      line-height: normal;
      color: #740B99;
      @include mediaDesktop($W1280) {
        font-size: 28px;
      }
    }
  }
}

:deep(.deposit-box) {
  padding: 28px 22px 22px;
  .deposit-recipient {
    display: inline-block;
    margin-top: 18px;
    margin-bottom: 18px;
    padding: 6px 11px;
    border: 1px solid #E0E3EB;
    border-radius: 3px;
    background: #F8F9FB;
    color: #002B49;
    font-size: 12px;
    line-height: 16px;

    .deposit-recipient-label {
      color: #73839B;
    }
  }

  .deposit-title {
    padding-bottom: 15px;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
  }

  .deposit-variant {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;

    .item {
      margin-bottom: 0;
      height: 120px;
      flex: 0 0 250px;
      align-items: center;
      display: flex;
      flex-direction: column;
      transition: all 400ms;
      position: relative;

      label {
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        margin: 0;
        border: 1px solid #C2CAD8;
        border-radius: 5px;
        position: relative;
        overflow: visible;
        padding-top: 12px;

        .recommended-badge {
          position: absolute;
          top: 8px;
          right: 12px;
          z-index: 2;
          background: #FFFFFF;
          color: #7C1A9F;
          border: 2px solid #7C1A9F;
          border-radius: 999px;
          padding: 4px 12px;
          font-size: 13px;
          line-height: 18px;
          box-shadow: 0 0px 0px rgba(116, 11, 153, 0.18);
          white-space: nowrap;
          pointer-events: none;
        }

        &:hover {
          background: rgba(116, 11, 153, 0.03);
          border: 1px solid #7C1A9F;

          .icon {
            img {
              opacity: 1;
              -webkit-filter: grayscale(0);
              filter: grayscale(0);
            }

            .payment-icon {
              background-color: #740B99;
            }
          }
        }
      }

      &.disabled {
        label {
          &:hover {
            border: 1px solid #C2CAD8;
            background: #fff;

            .icon {
              .payment-icon {
                background-color: #C2CAD8;
              }
            }

          }
        }

      }

      input {
        opacity: 0;
        visibility: hidden;
        position: absolute;

        &:checked + label {
          background: rgba(116, 11, 153, 0.03);
          border: 1px solid #7C1A9F;

          .icon {
            img {
              opacity: 1;
              -webkit-filter: grayscale(0);
              filter: grayscale(0);
            }

            .payment-icon {
              background-color: #740B99;
            }
          }
        }
      }

      .icon {
        height: 45px;
        justify-content: center;
        align-items: center;
        display: flex;

        .payoneer-logo {
          width: 100px;
          height: 25px;
          object-fit: contain;
        }

        img {
          opacity: 0.2;
          -webkit-filter: grayscale(1);
          filter: grayscale(1);
        }

        .payment-icon {
          display: inline-block;
          background-color: #C2CAD8;
          transition: background-color 400ms;
          -webkit-mask: var(--payment-icon) center / contain no-repeat;
          mask: var(--payment-icon) center / contain no-repeat;

          &-wire {
            width: 44px;
            height: 43px;
            --payment-icon: url('../images/wire-transfer-logo.svg');
          }

          &-paypal {
            width: 88.8px;
            height: 25.2px;
            --payment-icon: url('../images/paypal-logo.svg');
          }

          &-smartyads {
            width: 100px;
            height: 25px;
            --payment-icon: url('../images/billing-smartyads.svg');
          }
        }
      }

      .text {
        font-size: 12px;
        line-height: 20px;
      }
    }
  }

  .beneficiary {
    max-width: 525px;

    .dropdown {
      .dropdown-trigger {
        padding-top: 7px;
      }

      .input-wrap {
        padding: 0;
      }
    }
  }
}

.input-group-paypal .input-group-prepend {
  max-height: 35px !important;
}

#paypal-button {
  padding-top: 6px;
  max-height: 35px !important;
}

.table ::v-deep {
  td.transaction-download {
    padding-left: 37px;
  }

  .camp-name {
    width: 30%;
  }

  td {
    .completed {
      color: #740B99;
    }
  }
}

::v-deep .descr-field {
  white-space: normal !important;
}

.promo-added {
  margin-top: 15px;
  padding: 20px;
  background: #F6F6F8;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  width: max-content;

  .text {
    font-size: 12px;
    line-height: 20px;
    padding-left: 10px;
  }
}

.stripe-amount-wrap {
  margin-bottom: 25px;
  max-width: 350px;
}

.stripe-amount {
  width: 250px;
}

.actions-column {
  width: 160px !important;
}

.agency-switch {
  ::v-deep .button {
    background: transparent;
    border-width: 0 0 2px 0;
    border-color: transparent;
    border-radius: 0;
    box-shadow: none;

    &.active {
      border-color: #740B99;
    }
  }
}

.billing-notice {
  margin-top: 6px;
  margin-bottom: 25px;
  padding-top: 34px;
  padding-bottom: 35px;
  padding-left: 40px;
  padding-right: 40px;
  display: flex;
  flex-direction: row;
  background-color: rgba(116, 11, 153, 0.05);
  border-radius: 5px;
  align-items: center;
  box-shadow: (0px 4px 4px rgba(0, 0, 0, 0.25));

  .icon {

  }

  .text {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    color: #212B36;
  }

  .button-wrap {
    margin-left: auto;
  }
}

.disabled-wrap {
  opacity: 0.5;
  position: relative;
  z-index: 99;
}

.custom-footer {
  .modal-footer {
    width: 100%;

    .wrap {
      display: flex;
      align-self: flex-end;
    }
  }

}
.top-title-wrap {
  align-items: center;
  gap: 0 30px;
}
.form-group {
  &.w-100 {
    max-width: 100%;
  }
}

.disabled {
  cursor: not-allowed;

  .box  {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>

<style lang="scss">
// Modals are rendered outside the page container.
.billing-page,
.billing-modal,
.beneficiary-delete-modal {
  font-size: 12px;

  ::placeholder {
    font-size: 12px;
  }
}

// Notifications are rendered in App.vue (400px wide); widen them while the billing page is open,
// the payment request message is too long for that width.
#app:has(.billing-page) .vue-notification-group {
  width: min(640px, calc(100vw - 32px)) !important;
  left: 50% !important;
  transform: translateX(-50%);
}
</style>
